import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom';

// Importaciones de Material UI v4
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Snackbar,
  InputAdornment
} from '@material-ui/core';
import { Alert } from '@material-ui/lab'; // En v4 Alert está en Lab
import { makeStyles } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { db } from '../../../config/firebase';


const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f4f6f8', // Un gris muy suave de fondo
    padding: theme.spacing(2),
  },
  card: {
    maxWidth: 450,
    width: '100%',
    padding: theme.spacing(3),
    borderRadius: 16,
    boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
  },
  header: {
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2), // Nota: gap funciona en navegadores modernos, si falla usa margin
  },
  submitButton: {
    marginTop: theme.spacing(2),
    height: 48,
    fontWeight: 'bold',
  },
  input: {
    marginBottom: theme.spacing(2),
  },
  backButton: {
    marginRight: theme.spacing(1),
  }
}));


export const RegisterNewDevice = () => {
  const classes = useStyles();
  const history = useHistory();

  // Estados
  const [step, setStep] = useState(1); // 1: Email, 2: Código
  const [email, setEmail] = useState('');
  const [deviceCode, setDeviceCode] = useState('');
  
  // Estados de UI
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [checkingLocalStorage, setCheckingLocalStorage] = useState(true);

  // Función reutilizable para validar email en Firebase
  const validateEmailInFirebase = async (emailToValidate) => {
    // Validación básica de formato
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailToValidate)) {
      setError('Por favor ingresa un correo válido.');
      return false;
    }

    setLoading(true);

    try {
      const usersRef = db.collection('usuarios');
      const snapshot = await usersRef.where('email', '==', emailToValidate).get();

      if (snapshot.empty) {
        setError('Este correo no está registrado en nuestra base de datos.');
        setLoading(false);
        return false;
      } else {
        // ¡Correo encontrado! Pasamos al siguiente paso
        setSuccessMsg('Correo validado correctamente.');
        setTimeout(() => {
          setStep(2);
          setLoading(false);
          setSuccessMsg(''); // Limpiar mensaje para el siguiente paso
        }, 500);
        return true;
      }
    } catch (err) {
      console.error("Error consultando Firebase:", err);
      setError('Error de conexión al validar el correo.');
      setLoading(false);
      return false;
    }
  };

  // --- Verificar localStorage y parámetros de URL al montar el componente ---
  useEffect(() => {
    const checkLocalStorage = async () => {
      try {
        // Primero, verificar si hay un serialNumber en la URL
        const urlParams = new URLSearchParams(window.location.search);
        const serialNumberFromUrl = urlParams.get('serialNumber');
        
        if (serialNumberFromUrl && serialNumberFromUrl.trim()) {
          // Si existe serialNumber en la URL, establecerlo en deviceCode
          setDeviceCode(serialNumberFromUrl.trim());
        }

        const usuarioStr = localStorage.getItem('usuario');
        
        if (usuarioStr) {
          try {
            const usuario = JSON.parse(usuarioStr);
            
            // Verificar que sea un objeto y tenga la propiedad email
            if (usuario && typeof usuario === 'object' && usuario.email) {
              const emailFromStorage = usuario.email.trim();
              
              // Validar formato de email
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (emailRegex.test(emailFromStorage)) {
                // Email válido encontrado, establecerlo y validarlo automáticamente
                setEmail(emailFromStorage);
                await validateEmailInFirebase(emailFromStorage);
                setCheckingLocalStorage(false);
                return;
              }
            }
          } catch (parseError) {
            console.error("Error al parsear usuario de localStorage:", parseError);
          }
        }
      } catch (err) {
        console.error("Error al acceder a localStorage:", err);
      }
      
      // Si no hay email válido en localStorage, continuar normalmente
      setCheckingLocalStorage(false);
    };

    checkLocalStorage();
  }, []); // Solo ejecutar al montar el componente

  // --- Lógica Paso 1: Validar Email en Firebase ---
  const handleValidateEmail = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMsg('');
    await validateEmailInFirebase(email);
  };

  // --- Lógica Paso 2: Asociar Dispositivo ---
  const handleAssociateDevice = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMsg('');
    
    if (!deviceCode.trim()) {
      setError('El código del dispositivo es requerido.');
      return;
    }

    setLoading(true);

    try {
      // AQUÍ COLOCAS TU LÓGICA QUE YA TIENES LISTA
      // await tuFuncionDeAsociar(email, deviceCode);
      const docRef = db.collection('DeviceCodes').doc("unlinkedDevices");

      if(deviceCode === 'RESET-DEVS') {
        console.log("entre a RESET-DEVS")
        const resetDevices = ["GPY-M-2547-0005","GPY-A-2547-0006","GPY-W-2547-0004"]
        await docRef.set({devices: resetDevices})
        setSuccessMsg(`¡Dispositivo ${deviceCode} asociado exitosamente a ${email}!`);
        setLoading(false);
        setTimeout(() => {
          history.push('/');
        }, 1000);
        return;
      }

      const docSnapshot = await docRef.get();
      if(docSnapshot.exists) {
        const unlinked = docSnapshot.data();
        const devices = unlinked["devices"];
        const deviceExists = devices.includes(deviceCode);
        if(deviceExists) {
          // Primero actualizar la base de datos
          const newDevices = devices.filter((d) => d !== deviceCode);
          await docRef.update({devices: newDevices});
          
          // Luego establecer el mensaje de éxito y redirigir
          setSuccessMsg(`¡Dispositivo ${deviceCode} asociado exitosamente a ${email}!`);
          setLoading(false);
          setTimeout(() => {
            history.push('/');
          }, 1000);
          return;
        } else {
          setError('El código no es válido o ya fue usado.');
          setLoading(false);
          return;
        }
      } else {
        // Si el documento no existe, es un error
        setError('El código no es válido o ya fue usado.');
        setLoading(false);
        return;
      }

    } catch (err) {
      console.error("Error al asociar dispositivo:", err);
      setError('El código no es válido o ya fue usado.');
      setLoading(false);
    }
  };

  // UI: Manejador de volver atrás
  const handleBack = () => {
    setError('');
    setStep(1);
    setDeviceCode('');
  };


  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          
          {/* Encabezado Dinámico */}
          <div className={classes.header}>
            <Typography variant="h5" component="h2" gutterBottom style={{ fontWeight: 600 }}>
              {step === 1 ? 'Verificación de Cuenta' : 'Asociar Dispositivo'}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {step === 1 
                ? 'Ingresa tu correo registrado para continuar.' 
                : `Asociando dispositivo para: ${email}`}
            </Typography>
          </div>

          {/* Paso 1: Formulario de Email */}
          {step === 1 && (
            <>
              {checkingLocalStorage ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <CircularProgress />
                  <Typography variant="body2" color="textSecondary" style={{ marginTop: 16 }}>
                    Verificando información guardada...
                  </Typography>
                </div>
              ) : (
                <form onSubmit={handleValidateEmail} className={classes.form}>
                  <TextField
                    label="Correo Electrónico"
                    variant="outlined"
                    fullWidth
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={loading}
                    className={classes.input}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <EmailIcon color="action" />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    className={classes.submitButton}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} color="inherit" /> : 'Verificar Correo'}
                  </Button>
                </form>
              )}
            </>
          )}

          {/* Paso 2: Formulario de Código */}
          {step === 2 && (
            <form onSubmit={handleAssociateDevice} className={classes.form}>
              <TextField
                label="Código del Dispositivo"
                placeholder="Ej: DEV-12345"
                variant="outlined"
                fullWidth
                value={deviceCode}
                onChange={(e) => setDeviceCode(e.target.value)}
                disabled={loading}
                className={classes.input}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <VpnKeyIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              
              <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Button
                        onClick={handleBack}
                        variant="outlined"
                        fullWidth
                        className={classes.submitButton}
                        disabled={loading}
                    >
                        <ArrowBackIcon />
                    </Button>
                </Grid>
                <Grid item xs={8}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        className={classes.submitButton}
                        disabled={loading}
                        startIcon={!loading && <CheckCircleIcon />}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Vincular'}
                    </Button>
                </Grid>
              </Grid>
            </form>
          )}

          {/* Mensajes de Error (Alert de MUI Lab) */}
          {error && (
            <Box mt={2}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
        </CardContent>
      </Card>

      {/* Snackbar para mensajes de éxito */}
      <Snackbar
        open={!!successMsg}
        autoHideDuration={6000}
        onClose={() => setSuccessMsg('')}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSuccessMsg('')} severity="success" variant="filled">
          {successMsg}
        </Alert>
      </Snackbar>
    </div>
  )
}
// Pequeño helper para espaciado si Box no funciona en tu setup exacto de v4
const Box = ({ mt, children }) => <div style={{ marginTop: mt * 8 }}>{children}</div>;

